import React, { useEffect, useState } from 'react';
import { getGroupListPass, getDrStudentByGroup, getOpinionByGroupOpIdx0000 } from '../../../services/EP/EPApplyGroupService';
import CompletionCertificatePDF from '../../../components/CompletionCertificatePDF';
import CertificatePDF from '../../../components/CertificatePDF';

// 定義 Props 類型

// 定義資料介面
interface IGroup {
    ApplyName: string;
    ApplyNo: string;
    City: string;
    GroupName: string;
    GroupNo: string;
    IsTest?: boolean | null;
    RegFormUpload: string;
    SchoolFull: string;
    SchoolName: string;
    StudentCount: number;
    StudentList: string;
    TeacherCount: number;
    TeacherList: string;
    type: string;
    FlagRevOk?: string;
    FinalOrder?: string;
    GroupTypeStr?: string;
    Topic?: string;
    TeacherName?: string;
    Prize?: string; // Added Prize to the interface
}
interface TeamAwardsTableProps {
    type: string | null;
    ishidden: boolean;
    onClose: () => void;
    filterFlagRevOk?: boolean;
    filterAwarded?: boolean;
}

const TeamAwardsTable: React.FC<TeamAwardsTableProps> = ({ type, ishidden, onClose, filterFlagRevOk, filterAwarded }) => {
    const [Grouplist, setGroupList] = useState<IGroup[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        let fetchData = async () => {
            setIsLoading(true);
            if (type) {
                try{
                    let fetchResult = (await getGroupListPass()) as IGroup[];
                    console.log('原始資料:', fetchResult);
                    console.log('篩選條件:', { type: type, filterFlagRevOk: filterFlagRevOk, filterAwarded: filterAwarded });
                    
                    // 基本篩選：組別和測試資料
                    fetchResult = fetchResult.filter(x => x.type === type && !x.IsTest);
                    console.log('篩選後資料:', fetchResult);
                    
                    // 如果需要篩選 FlagRevOk = 1 (決賽名單)
                    if (filterFlagRevOk) {
                        fetchResult = fetchResult.filter(x => x.FlagRevOk == '1');
                        // 每組最多取20組
                        fetchResult = fetchResult.slice(0, 20);
                        console.log('決賽名單篩選後:', fetchResult);
                    }

                    if (filterAwarded) {
                        fetchResult = fetchResult.filter((item: any) => item.FinalOrder && parseInt(item.FinalOrder, 10) > 0);
                        
                        // 根據獎項和小隊編號排序
                        const prizeOrder: { [key: string]: number } = { '特優': 1, '優等': 2, '佳作': 3 };
                        fetchResult.sort((a, b) => {
                            const prizeA = prizeOrder[a.Prize || ''] || 99;
                            const prizeB = prizeOrder[b.Prize || ''] || 99;

                            if (prizeA !== prizeB) {
                                return prizeA - prizeB;
                            }
                            return (a.GroupNo || '').localeCompare(b.GroupNo || '');
                        });
                    }
                    
                    setGroupList(fetchResult);

                }catch (ex){
                    console.log("TeamAward 錯誤:",ex)
                } finally {
                    setIsLoading(false);
                }
            } else {
                setGroupList([]);
                setIsLoading(false);
            }
        };

        fetchData();
    }, [type, filterFlagRevOk, filterAwarded]);

    return (
     
        <div className="text-center pb-3 px-0 mt-3"  style={{ height: 'auto', maxHeight: '530px', overflowY: 'auto' }} >
          
     
        {type}  {Grouplist.length ? Grouplist.length+'組' : (isLoading ? '' : "沒有資料")}
        
            <div className="p-2 mx-3 my-4 ">
                {isLoading ? (
                    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                ) : (
                    type?(
                        <div className="table-responsive text-start">
                            <table className="text-sm table table-striped">
                                <thead>
                                    <tr className="font-weight-bolder text-nowrap" style={{ color: '#5c71a2', background: '#d9dce6' }}>
                                        {filterAwarded ? (
                                            <>
                                                <th className="p-2">獎項</th>
                                                <th className="p-2">小隊編號</th>
                                                <th className="p-2">小隊名稱</th>
                                                <th className="p-2">學校</th>
                                                <th className="p-2">題目</th>
                                            </>
                                        ) : (
                                            <>
                                                <th className="p-2">No</th>
                                                <th className="p-2">縣市</th>
                                                <th className="p-2">學校</th>
                                                <th className="p-2">小隊編號</th>
                                                <th className="p-2">小隊名稱</th>
                                                {filterFlagRevOk && <th className="p-2">順序</th>}
                                            </>
                                        )}
                                    </tr>
                                </thead>
                                <tbody>
                                    {Grouplist.map((team, index) => (
                                        <tr key={index}>
                                            {filterAwarded ? (
                                                <>
                                                    <td>{team.Prize || '-'}</td>
                                                    <td>{team.GroupNo}</td>
                                                    <td>{team.GroupName}</td>
                                                    <td>{team.SchoolName}</td>
                                                    <td>{team.Topic}</td>
                                                </>
                                            ) : (
                                                <>
                                                    <td>{index + 1}</td>
                                                    <td>{team.City}</td>
                                                    <td>{team.SchoolName}</td>
                                                    <td>{team.GroupNo}</td>
                                                    <td>{team.GroupName}</td>
                                                    {filterFlagRevOk && <td>{team.FinalOrder || '-'}</td>}
                                                </>
                                            )}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : <div className="text-center p-5">沒有資料</div>
                )}
                {/* <div className="mt-3 me-auto text-secondary">依獎項和小隊編號排列</div> */}
            
            </div>
        </div>
    );
};
export default TeamAwardsTable;
